export default __webpack_public_path__ + "static/media/TestBook.4224260b6c6874c47019d91701dcab29.webp";